export default __webpack_public_path__ + "static/media/profile.21b9a8e3.svg";